export const getReservedFileTagValues = () => ([
  'filename', 'file_extension', 'file_folder_path', 'fileid', 'projectid', 'filecontent',
  'filecreationyear', 'filecreationmonth', 'filecreationday', 'filecreationhour', 'filecreationminute', 'filecreationsecond',
  'filemodificationyear', 'filemodificationmonth', 'filemodificationday', 'filemodificationhour', 'filemodificationminute', 'filemodificationsecond'
]);

export const buildReservedTagSet = (systemTagsEvent = [], systemTagsGlobal = []) => {
  const systemValues = [...systemTagsEvent, ...systemTagsGlobal]
    .map(tag => (tag?.value || '').toLowerCase())
    .filter(Boolean);
  return new Set([
    ...getReservedFileTagValues(),
    ...systemValues
  ]);
};

export const getSafeTagVariable = (value, reservedSet) => {
  const baseValue = (value || '').trim();
  if (!baseValue) return '';

  const normalizedReserved = reservedSet
    ? new Set([...reservedSet].map(val => (val || '').toLowerCase()))
    : new Set();
  let candidate = baseValue;
  let counter = 1;

  while (normalizedReserved.has(candidate.toLowerCase())) {
    candidate = `${baseValue}_${counter}`;
    counter += 1;
  }

  return candidate;
};
